import { EdgeProps, getStraightPath } from 'reactflow'

const useEdge = (props: EdgeProps) => {
  const { markerEnd, style, sourceX, sourceY, targetX, targetY } = props

  const [path] = getStraightPath({
    sourceX: sourceX - 18,
    sourceY,
    targetX: targetX + 18,
    targetY
  })

  return {
    markerEnd,
    style,
    path
  }
}

export default useEdge
